import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies';
import { initOffcanvas } from './shared/offcanvas';
import { initContactLoader } from './shared/contact_loader';
import { initASwap } from './aswap'
import { loadingSequence } from './loading';

WCAG.init()
initCommon()
initCookies()
initOffcanvas()
initContactLoader()
// initASwap()
loadingSequence()